import { render, staticRenderFns } from "./RPSScenario.vue?vue&type=template&id=57b8087f&scoped=true"
import script from "./RPSScenario.vue?vue&type=script&lang=js"
export * from "./RPSScenario.vue?vue&type=script&lang=js"
import style0 from "./RPSScenario.vue?vue&type=style&index=0&id=57b8087f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8087f",
  null
  
)

/* custom blocks */
import block0 from "./RPSScenario.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports